import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Row, Col, Collapse, Switch, Input, Form, Card, Select, Button, message, Spin, Icon } from 'antd';
import store from 'store';
import moment from 'moment';
import { ssCommonUtils, ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';

const { unixSecondsToTimestampString } = ssDateUtils;

export default class ViewUserCommon extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }

    getFormattedDate(accountDate){
      if (accountDate==="")
      {
        return "";
      }

      return moment(accountDate).format("YYYY-MMM-DD");
    }

    getFormattedDateWithTime(accountDate){
      if (accountDate==="")
      {
        return "";
      }

      return unixSecondsToTimestampString(accountDate);
    }


     getFSDOName() {
       if(this.props.viewUserCommonData.roles){
       const role = this.props.viewUserCommonData.roles[0].role;
       if(role=="FSDO"){

         return(<Row>
                     <Col span={12}>
                           {'Office:'}
                    </Col>
                     <Col span={12}>
                           {String(this.props.viewUserCommonData.fsdoInformation.fsdoName)}
                       </Col>
                    </Row>);
         }
       }

     }
     getFSDORegion(){
       if(this.props.viewUserCommonData.roles){
       const role = this.props.viewUserCommonData.roles[0].role;
       if(role=="FSDO"){

                    return (<Row>
                       <Col span={12}>
                           {'Region:'}
                       </Col>
                       <Col span={12}>
                           {String(this.props.viewUserCommonData.fsdoInformation.fsdoRegion)}
                       </Col>
                   </Row>);
         }
       }

     }


    render() {
        return (
                                <Row>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={12}>
                                                {'User ID:'}
                                            </Col>
                                            <Col span={12}>
                                                {String(this.props.viewUserCommonData.userName)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Email:'}
                                            </Col>
                                            <Col span={12}>
                                                {String(this.props.viewUserCommonData.emailAddress)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Status:'}
                                            </Col>
                                            <Col span={12}>
                                                {ssCommonUtils.reverseLookup( this.props.commonData.lookupData.lookupDataStore, 'ACCT_STATUS', this.props.viewUserCommonData.status )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Last Login:'}
                                            </Col>
                                            <Col span={12}>
                                                {this.getFormattedDateWithTime(this.props.viewUserCommonData.lastLogin)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Password Expiration:'}
                                            </Col>
                                            <Col span={12}>
                                                {this.getFormattedDateWithTime(this.props.viewUserCommonData.passwordExpiration)}
                                            </Col>
                                        </Row>
                                        {this.getFSDOName()}
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={12}>
                                                {'Name:'}
                                            </Col>
                                            <Col span={12}>
                                                {String(this.props.viewUserCommonData.firstName)} {String(this.props.viewUserCommonData.middleName)} {String(this.props.viewUserCommonData.lastName)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Phone:'}
                                            </Col>
                                            <Col span={12}>
                                                {this.props.viewUserCommonData.phoneNumber?String(this.props.viewUserCommonData.phoneNumber):""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Account Created:'}
                                            </Col>
                                            <Col span={12}>
                                                {this.getFormattedDateWithTime(this.props.viewUserCommonData.createdDate)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Locked Date:'}
                                            </Col>
                                            <Col span={12}>
                                                {this.getFormattedDate(this.props.viewUserCommonData.lockedDate)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                {'Login Failures:'}
                                            </Col>
                                            <Col span={12}>
                                                {String(this.props.viewUserCommonData.loginFailures)}
                                            </Col>
                                        </Row>
                                        {this.getFSDORegion()}
                                        </Col>

                                </Row>
        );
    }
}
